import type { CustomerPrivacyRequestStatus } from '../../customerPrivacyApi'

type PrivacyRequestStatusProps = {
  status: CustomerPrivacyRequestStatus
}

const STATUS_CLASSNAMES: Record<CustomerPrivacyRequestStatus, string> = {
  pending: 'ca-badge-warning',
  processing: 'ca-badge-info',
  completed: 'ca-badge-success',
  rejected: 'ca-badge-error',
  expired: 'ca-badge-neutral',
}

const STATUS_LABELS: Record<CustomerPrivacyRequestStatus, string> = {
  pending: 'Pending',
  processing: 'In corso',
  completed: 'Completata',
  rejected: 'Rifiutata',
  expired: 'Scaduta',
}

export const PrivacyRequestStatus = ({ status }: PrivacyRequestStatusProps) => (
  <span
    className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold ${STATUS_CLASSNAMES[status]}`}
  >
    {STATUS_LABELS[status]}
  </span>
)
